import script from "./RallyPaginationMixin.vue?vue&type=script&lang=js"
export * from "./RallyPaginationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__